// Reusable US Letter VICS Bill of Lading (parties, order + carrier tables, signatures).
// Generated by scripts/wms/generate.ts for PHP-420. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomVicsBillOfLadingFileDataSchema = yup.object().shape({
  bolDate: yup.string().nullable().optional(),
  bolNumber: yup.string().nullable().optional(),
  shipFromName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  shipFromCityStateZip: yup.string().nullable().optional(),
  shipFromSid: yup.string().nullable().optional(),
  shipToName: yup.string().nullable().optional(),
  shipToLocationNumber: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  shipToCityStateZip: yup.string().nullable().optional(),
  shipToCid: yup.string().nullable().optional(),
  billTo: yup.object().shape({
    billToName: yup.string().nullable().optional(),
    billToAddress: yup.string().nullable().optional(),
    billToCityStateZip: yup.string().nullable().optional(),
  }),
  specialInstructions: yup.string().nullable().optional(),
  carrierName: yup.string().nullable().optional(),
  trailerNumber: yup.string().nullable().optional(),
  sealNumbers: yup.string().nullable().optional(),
  scac: yup.string().nullable().optional(),
  proNumber: yup.string().nullable().optional(),
  freightChargeTerms: yup.string().nullable().optional(),
  masterBolIndicator: yup.string().nullable().optional(),
  headerBarcode: yup.string().nullable().optional(),
  weightUom: yup.string().nullable().optional(),
  feeTermsCollect: yup.string().nullable().optional(),
  feeTermsPrepaid: yup.string().nullable().optional(),
  customerCheckAcceptable: yup.string().nullable().optional(),
  trailerLoadedByShipper: yup.string().nullable().optional(),
  trailerLoadedByDriver: yup.string().nullable().optional(),
  freightCountedByShipper: yup.string().nullable().optional(),
  freightCountedByDriverPallets: yup.string().nullable().optional(),
  freightCountedByDriverPieces: yup.string().nullable().optional(),
  customerOrderRows: yup
    .array()
    .of(
      yup.object().shape({
        customerOrderNumber: yup.string().nullable().optional(),
        packageCount: yup.string().nullable().optional(),
        orderWeight: yup.string().nullable().optional(),
        palletSlip: yup.string().nullable().optional(),
        additionalShipperInfo: yup.string().nullable().optional(),
      }),
    )
    .required(),
  carrierInfoRows: yup
    .array()
    .of(
      yup.object().shape({
        handlingUnitQty: yup.string().nullable().optional(),
        handlingUnitType: yup.string().nullable().optional(),
        packageQty: yup.string().nullable().optional(),
        packageType: yup.string().nullable().optional(),
        rowWeight: yup.string().nullable().optional(),
        hazmat: yup.string().nullable().optional(),
        commodityDescription: yup.string().nullable().optional(),
        nmfcNumber: yup.string().nullable().optional(),
        freightClass: yup.string().nullable().optional(),
      }),
    )
    .required(),
  codAmount: yup.string().nullable().optional(),
  shipperSignature: yup.string().nullable().optional(),
  carrierSignature: yup.string().nullable().optional(),
})

export type BiomVicsBillOfLadingFileData = yup.InferType<typeof biomVicsBillOfLadingFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<BiomVicsBillOfLadingFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomVicsBillOfLadingFileMappings: RequiredFileData = {
  bolDate: '025f75df-6a0d-4d8c-a133-654d9f57a124',
  bolNumber: '08dff7b8-576a-4e7b-9404-e6007a5c24f4',
  shipFromName: '0b19d8e9-1787-4da6-8ce1-354059e183c7',
  shipFromAddress: '99bb3cc9-449d-4ac6-b487-98b03f4e452a',
  shipFromCityStateZip: 'c198f1b5-dcd8-4c82-89b0-b439be598608',
  shipFromSid: '44aed311-6a54-4cb1-b788-625c507f3df3',
  shipToName: 'eb9c8e10-d641-4a2d-938b-1c65dc941e81',
  shipToLocationNumber: 'e51be409-8333-4dd0-9c06-0f79b6f73102',
  shipToAddress: '0b447649-7c7c-4358-ad1e-b0be5b17178e',
  shipToCityStateZip: 'f04c7442-1514-4e7c-87f1-e0c011840458',
  shipToCid: '4edd8852-b02b-4ff6-a346-81146cf8f728',
  billTo: {
    billToName: 'c79488cb-366f-403d-9207-c0e6d8a288e1',
    billToAddress: '72f03983-a3f1-48ae-b9da-3b6bac104ce8',
    billToCityStateZip: 'c5cebb13-2424-4c49-b828-f021a2c87e5c',
  },
  specialInstructions: '8ae530e6-25d5-40d1-8e5b-f77b307f9be3',
  carrierName: 'efd7d043-674f-4f1d-8942-d86fb808828d',
  trailerNumber: 'b3c76483-c3f8-475f-9fe2-c114d86ce477',
  sealNumbers: '960ba72a-6ce0-49fa-a193-0e5d1d6ea8e9',
  scac: 'f2559cc4-4984-4611-809b-d1e0f5affa75',
  proNumber: '5e3847c7-93eb-47d3-91cb-afb5a6e3998c',
  freightChargeTerms: '2e6a5f7d-9836-4232-97ce-86adf5b98bc9',
  masterBolIndicator: 'f8d66274-0cbf-4ba6-a1b6-2af81f9dd7f3',
  headerBarcode: '256c958d-3f5d-445f-a971-2117406e1ed2',
  weightUom: 'a00af1d6-3f85-4fed-9787-c9891a943925',
  feeTermsCollect: '5ba5169d-0a88-41bb-af79-7b82adcca047',
  feeTermsPrepaid: 'daede375-ffea-44a7-b1fc-ee6e64bcdc13',
  customerCheckAcceptable: '69d1f4a8-3449-4652-af3b-b7f8bc5b4a02',
  trailerLoadedByShipper: '10862925-a06a-4331-a3a0-85595ff8ff47',
  trailerLoadedByDriver: 'a3b77942-1aa6-43c5-a1f0-220932ea3d6b',
  freightCountedByShipper: 'bac1e7a6-ef50-4238-be1f-d60a0c1f2fdc',
  freightCountedByDriverPallets: '5669fb24-7d1f-45f5-8b16-5bfea3b05aa4',
  freightCountedByDriverPieces: '8e4b51af-8a2d-481e-821f-03d4880a0550',
  customerOrderRows: [
    {
      customerOrderNumber: 'c179724b-e417-457f-a174-f5f3792bbd04',
      packageCount: '8d42f136-10bc-4f38-8626-cc3648182191',
      orderWeight: '6492b1db-1731-4106-9d6c-b0da316db940',
      palletSlip: '14c31cc0-b31f-4253-9cca-5bf0655a86b7',
      additionalShipperInfo: 'aefb4998-0a22-49ba-af84-bde0e6e70cfb',
    },
  ],
  carrierInfoRows: [
    {
      handlingUnitQty: 'e602f401-b924-4a63-98fc-aaa31a660151',
      handlingUnitType: 'd2a5f305-a7ef-484f-9b78-5753b550b0ff',
      packageQty: 'a5a4c66e-c7f4-41bc-81e6-52d257a626c9',
      packageType: '4e523049-b2d5-4eff-bc28-056d2b5ba8c3',
      rowWeight: 'fe9f362f-442c-4740-af84-785133704ec2',
      hazmat: 'e13d6f13-58f2-49e3-8040-efade53b2c33',
      commodityDescription: '73358150-c271-4152-85ed-6a9d7d6a58df',
      nmfcNumber: '979c2211-095b-4e0d-bec4-66bb28c17b35',
      freightClass: '6f848c4d-a5ae-4711-b3e6-200ece7e85fe',
    },
  ],
  codAmount: '6d7d761f-ebb2-4ac2-8ceb-cf999172ae4e',
  shipperSignature: '013c6c55-b49a-47c0-ac48-4af9d069bfd4',
  carrierSignature: '4e790d00-228b-473d-ae55-f003017a3f22',
}
